'use client';

import { useState } from 'react';

import { logGreen } from 'utils/debugger';

import { useRosService } from '../index';

/**
 * Used for name the janus channels
 */
export enum RobotStream {
  PRIMARY_STREAM = 'PrimaryStream0',
  PRIMARY_STREAM_2 = 'PrimaryStream1',
  PRIMARY_STREAM_3 = 'PrimaryStream2',
  PRIMARY_STREAM_4 = 'PrimaryStream3',
  POP_OUT_VIEW = 'PopOutView',
  OPEN_DOOR_VIEWER = 'openDoorViewer',
  SPOT_SERVICE_NCB = 'ServiceNCB',
}

enum RequestStreamChangeAction {
  REQUEST_STREAM = 'REQUEST_STREAM',
  CLOSE_CHANNEL = 'CLOSE_CHANNEL',
}

type RequestStreamChangeChannel = {
  channelName: string;
  streamSource: string | null;
  action: RequestStreamChangeAction;
  requested_frame_size_height_width?: [number, number] | null;
};

export type RequestStreamChangePayload = {
  requestedStreamChanges?: RequestStreamChangeChannel[] | null;
  streamingHalted?: boolean | null;
  implicitCloseOthers?: boolean | null;
};

type ChangeStreamSourceProps = {
  channelName: RobotStream;
  streamSource: string;
  frameSize?: [number, number];
};

export function useRequestStreamChange() {
  const { RosServices } = useRosService();
  const [loading, setLoading] = useState(false);

  async function requestStreamChange(payload: RequestStreamChangePayload) {
    setLoading(true);
    await RosServices.requestStreamChange(payload).finally(() => setLoading(false));
  }

  function closeStream(channelName: RobotStream) {
    logGreen('📹📹📹 Request stream change:close', channelName);
    return requestStreamChange({
      requestedStreamChanges: [
        {
          channelName,
          streamSource: null,
          action: RequestStreamChangeAction.CLOSE_CHANNEL,
        },
      ],
      streamingHalted: null,
      implicitCloseOthers: null,
    });
  }

  async function closeAllStreams() {
    logGreen('📹📹📹 Request stream change:close - all');
    return requestStreamChange({
      streamingHalted: true,
      implicitCloseOthers: true,
    });
  }

  function changeStreamSource({ channelName, streamSource, frameSize }: ChangeStreamSourceProps) {
    logGreen('📹📹📹 Request stream change:source', channelName, streamSource);
    const requestedStreamChange: RequestStreamChangeChannel = {
      channelName,
      streamSource,
      action: RequestStreamChangeAction.REQUEST_STREAM,
      requested_frame_size_height_width: frameSize ?? [720, 1280],
    };

    return requestStreamChange({
      requestedStreamChanges: [requestedStreamChange],
      streamingHalted: null,
      implicitCloseOthers: null,
    });
  }

  return { loading, closeAllStreams, changeStreamSource, closeStream };
}
